export enum OrderView {
  AwaitingDispatch = 'awaiting_dispatch',
  MyOrder = 'my_orders',
  Order = 'orders',
}
